var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonProfits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2724_64203",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2724_64203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.925 11.05L8.675 6.79995L10.1 5.39995L12.925 8.22495L18.6 2.57495L20 3.97495L12.925 11.05ZM14 22.5L7 20.55V22H1V11H8.95L15.15 13.3C15.7 13.5 16.1458 13.85 16.4875 14.35C16.8292 14.85 17 15.4 17 16H19C19.8333 16 20.5417 16.275 21.125 16.825C21.7083 17.375 22 18.1 22 19V20L14 22.5ZM3 20H5V13H3V20ZM13.95 20.4L19.9 18.55C19.85 18.3666 19.7375 18.2291 19.5625 18.1375C19.3875 18.0458 19.2 18 19 18H14.2C13.6833 18 13.2167 17.9666 12.8 17.9C12.3833 17.8333 11.9333 17.7166 11.45 17.55L9.725 16.95L10.3 15.05L12.3 15.7C12.6 15.8 12.95 15.875 13.35 15.925C13.75 15.975 14.3 16 15 16C15 15.8166 14.9458 15.6416 14.8375 15.475C14.7292 15.3083 14.6 15.2 14.45 15.15L8.6 13H7V18.5L13.95 20.4Z",
    fill: "#707072"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonProfits);
export default __webpack_public_path__ + "static/media/Non-profits.b3114c71.svg";
export { ForwardRef as ReactComponent };